import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { Search, Eye, FileText, ArrowRight } from "lucide-react";

const TOOLS = [
  {
    to: "/tools/rank-checker",
    icon: Search,
    title: "Free Rank Checker",
    body: "Instantly check where your domain ranks for any keyword — Google, mobile or desktop, any country.",
    testid: "tool-rank-checker",
    gated: true,
  },
  {
    to: "/tools/serp-preview",
    icon: Eye,
    title: "SERP Preview Tool",
    body: "See exactly how your title tag and meta description will render in Google search results.",
    testid: "tool-serp-preview",
  },
  // Temporarily hidden — the Meta Title & Description Checker is being
  // rebuilt. Uncomment this entry (and the /tools/meta-checker route in
  // App.js) once the new version ships.
  // {
  //   to: "/tools/meta-checker",
  //   icon: FileText,
  //   title: "Meta Title & Description Checker",
  //   body: "Validate title and description lengths, catch truncation before Google does, and get a quick health score.",
  //   testid: "tool-meta-checker",
  // },
];

export default function ToolsHub({ embedded = false }) {
  const Wrapper = embedded ? "div" : "section";
  return (
    <>
      {!embedded && <SEO pageKey="tools" title="Free SEO Tools — SerpNex" description="Free SEO tools: Rank Checker, SERP Preview, Meta Title/Description Checker. Instant results, no signup for two of them." canonical="/tools" />}
      <Wrapper className={embedded ? "p-8" : "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-24"}>
        <div className="eyebrow">Free tools</div>
        <h1 className={`mt-3 ${embedded ? 'text-3xl' : 'h-display text-5xl sm:text-6xl'} font-bold text-[#0A0D14]`}>
          {embedded ? "Free SEO tools" : (<>Two tools.<br /><span className="text-[#0047FF]">Zero fluff.</span></>)}
        </h1>
        {!embedded && <p className="mt-4 text-[17px] text-[#525B6A] max-w-2xl">Instant answers to the questions every SEO asks daily. Free, browser-based, and honest.</p>}

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {TOOLS.map((t) => (
            <Link to={t.to} key={t.to} data-testid={t.testid} className="card-crisp p-6 group hover:border-[#0047FF] transition-colors relative">
              <div className="h-10 w-10 rounded-md bg-[#E0E7FF] text-[#0047FF] flex items-center justify-center mb-4">
                <t.icon className="h-5 w-5" />
              </div>
              <div className="text-lg font-display font-semibold text-[#0A0D14]">{t.title}</div>
              <div className="mt-2 text-sm text-[#525B6A] leading-relaxed">{t.body}</div>
              <div className="mt-4 text-sm text-[#0047FF] inline-flex items-center gap-1">Open tool <ArrowRight className="h-3.5 w-3.5 group-hover:translate-x-0.5 transition-transform" /></div>
              {t.gated && <span className="absolute top-4 right-4 pill pill-accent">Email required</span>}
            </Link>
          ))}
        </div>
      </Wrapper>
    </>
  );
}
